export default __webpack_public_path__ + "static/media/5.e706c9de.JPG";